import React, { useState } from "react";
import ModalPopup from "../Common/Modal/Modal";
import { IoMdShareAlt } from "react-icons/io";
import { ShareCredential } from "../../Api/SuperAdminVault/Credentials";
import { SendDocumentMail } from "../../Api/SuperAdminVault/Documents";
import { ShareContactMail } from "../../Api/SuperAdminVault/Contacts";
import OtpModal from "./OtpModal";

const validateEmail = (value = "") => {
  const emailValue = value.trim();
  const invalidEmailMessage = "Invalid email format";

  if (!emailValue) {
    return "Email is required";
  }

  if (/\s/.test(emailValue)) {
    return "Spaces are not allowed";
  }

  const atCount = (emailValue.match(/@/g) || []).length;

  if (atCount !== 1) {
    return invalidEmailMessage;
  }

  const [localPart, domain] = emailValue.split("@");

  if (!localPart || !domain) {
    return invalidEmailMessage;
  }

  const localRegex = /^[a-zA-Z0-9]+[a-zA-Z0-9._%]*[a-zA-Z0-9]$/;

  if (!localRegex.test(localPart)) {
    return invalidEmailMessage;
  }

  if (/[^a-zA-Z0-9.-]/.test(domain)) {
    return "Special characters are not allowed in domain";
  }

  if (!domain.includes(".")) {
    return invalidEmailMessage;
  }

  if (domain.includes("..")) {
    return invalidEmailMessage;
  }

  if (domain.startsWith(".") || domain.endsWith(".")) {
    return invalidEmailMessage;
  }

  const domainParts = domain.split(".");

  if (domainParts.some((part) => !part)) {
    return invalidEmailMessage;
  }

  const tld = domainParts[domainParts.length - 1];

  if (!/^[a-zA-Z]{2,}$/.test(tld)) {
    return invalidEmailMessage;
  }

  if (
    domainParts.length >= 2 &&
    domainParts[domainParts.length - 1].toLowerCase() ===
      domainParts[domainParts.length - 2].toLowerCase()
  ) {
    return invalidEmailMessage;
  }

  return "";
};

const ShareModal = ({ show, onClose, previewContent, module, id, isSens }) => {
  const [email, setEmail] = useState("");
  const [showOtpScreen, setShowOtpScreen] = useState(false);
  const [emailError, setEmailError] = useState("");

  const handleClose = () => {
    onClose?.();
    setEmail("");
    setEmailError("");
    setShowOtpScreen(false);
  };

  const handleShare = () => {
    const errorMessage = validateEmail(email);

    if (errorMessage) {
      setEmailError(errorMessage);
      return;
    }

    const finalEmail = email.trim();

    if (module === "credentials") {
      ShareCredential(id, finalEmail).then((response) => {
        if (isSens === true) {
          setShowOtpScreen(true);
          return;
        }

        if (response) {
          handleClose();
        }
      });
    }

    if (module === "documents") {
      SendDocumentMail({
        documentId: id,
        email: finalEmail,
      }).then((response) => {
        if (isSens === true || response?.action === "OTP_REQUIRED") {
          setShowOtpScreen(true);
          return;
        }

        handleClose();
      });
    }

    if (module === "contacts") {
      ShareContactMail({
        contact_id: id,
        email: finalEmail,
      }).then((response) => {
        if (isSens === true) {
          setShowOtpScreen(true);
          return;
        }

        handleClose();
      });
    }
  };

  return (
    <>
      {!showOtpScreen ? (
        <ModalPopup show={show} onClose={handleClose}>
          <div className="flex flex-col justify-center items-center min-w-[50vw]">
            <h2 className="text-[#1f4b7f] font-semibold text-2xl text-center">
              {isSens === false ? "Share Instantly" : "Share Securely"}
            </h2>

            <div className="flex flex-col gap-2 w-[50%] mt-2 relative">
              <label htmlFor="email" className="text-center">
                Recipient Email <span className="text-red-500">*</span>
              </label>

              <input
                type="text"
                id="email"
                placeholder="name@company.com"
                className="border-[0.2px] border-black rounded-md px-2 py-1"
                value={email}
                onChange={(e) => {
                  const value = e.target.value.replace(/\s/g, "");
                  setEmail(value);

                  if (emailError) {
                    setEmailError("");
                  }
                }}
              />

              {emailError && (
                <p className="text-red-500 text-sm absolute top-16 left-2">
                  {emailError}
                </p>
              )}
            </div>

            <div className="w-full flex flex-col gap-2 mt-4 mb-2">
              <h3 className="text-center">Here’s what they’ll see</h3>

              <div className="border-[0.2px] border-black border-dotted bg-zinc-200 rounded-md px-2 py-1">
                {previewContent}
              </div>
            </div>

            <button
              className="bg-[#1f4b7f] text-white px-2 py-1 rounded-md flex justify-center items-center gap-1"
              onClick={handleShare}
            >
              <IoMdShareAlt size="1.3vw" color="#fff" />
              Share
            </button>
          </div>
        </ModalPopup>
      ) : (
        <OtpModal
          showOtpScreen={showOtpScreen}
          id={id}
          email={email.trim()}
          onClose={handleClose}
          setShowOtpScreen={setShowOtpScreen}
          module={module}
          setEmail={setEmail}
        />
      )}
    </>
  );
};

export default ShareModal;
